const ContactForm = () => {
  const $container = $('body')
  const $form = $container.find('[data-role="contact-form"]')
  const $contactForm = $container.find('.wpcf7-form__contact')

  if (!$form.length) return

  if ($contactForm.length) return

  const $submit = $form.find('.wpcf7-submit')

  $submit.on('click', () => {
    $submit.attr('disabled', true)
  })
}

export default ContactForm



// WEBPACK FOOTER //
// ./scripts/components/ContactForm.js